import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TableColumnsType } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import useToast from '../../../hook/useToast';
import useThrottle from '../../../hook/useThrottle';
import useDebounce from '../../../hook/useDebounce';
import * as networkApi from '../../../api/network/networkApi';
import { URL_NETWORK } from '../../../env';
import Layout from '../../../Layout';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import SMSFeesSetting from './ItemFeesSetting/SMSFeesSetting';
import ZNSFeesSetting from './ItemFeesSetting/ZNSFeesSetting';
import EmailFeesSetting from './ItemFeesSetting/EmailFeesSetting';
import { CHANNELTYPE } from '../../../services/data';
import useLoading from '../../../hook/useLoading';
import { network_operator } from '../../../components/ExportImgFigma';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { checkDisabledPermission, formatPrice, getUserPermissions } from '../../../until';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
// TABLE
interface DataTypeSMS {
  key: React.Key;
  nhaMang: string;
  nhaMangImg: string;
  dauSo: string;
  soLuongKyTu: number;
  chiPhi: number;
  category: string
  typeZNSType: string
  numberEmail: number
  messageType?: string
}

const currencyFormat = (number: any) => {
  try {
    number = parseInt(number);
    const formattedNumber = new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(number);
    return formattedNumber;
  } catch (error) {
    return number;
  }
};

const NotificationFeesSetting_V2: React.FC = () => {

  const columnsSMS: TableColumnsType<DataTypeSMS> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_, record) =>
        <div className='d-flex gap-2 align-center  h-full px-1'>
          <EditOutlined
            className={`border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoNetwork(record.key)} />
          <DeleteOutlined
            className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => openModalDelete(Number(record.key))}
          />
        </div>
    },
    {
      title: 'Nhà mạng',
      dataIndex: 'nhaMang',
      key: 'nhaMang',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <img
            alt=""
            style={{ objectFit: 'contain' }}
            src={record.nhaMangImg}
            onError={(e) => {
              e.currentTarget.src = network_operator;
            }}
          />
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },
    {
      title: 'Loại tin nhắn',
      dataIndex: 'messageType',
      key: 'messageType',
      render: (value) => (
        <span className="neutral-gray-500">{value}</span>
      )
    },
    {
      title: 'Đầu số',
      dataIndex: 'dauSo',
      key: 'dauSo',
      render: (value) => (
        <span className="neutral-gray-500">{value}</span>
      )
    },
    {
      title: 'Số lượng ký tự tính là 1 tin',
      dataIndex: 'soLuongKyTu',
      key: 'soLuongKyTu',
      align: 'right',
      render: (value) => (
        <span className="neutral-gray-500">{value} ký tự</span>
      )
    },
    {
      title: 'Chi phí cho 1 tin',
      dataIndex: 'chiPhi',
      key: 'chiPhi',
      align: 'right',
      render: (value) => (
        <span className="neutral-gray-500">{currencyFormat(value)}</span>
      )
    },
  ]
  const columnsZNS: TableColumnsType<DataTypeSMS> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_, record) =>
        <div className='d-flex gap-2  align-center  h-full px-1'>
          <EditOutlined
            className={`border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoNetwork(record.key)} />
          <DeleteOutlined
            className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => openModalDelete(Number(record.key))}
          />
        </div>
    },
    {
      title: 'Mẫu ZNS',
      dataIndex: 'typeZNSType',
      key: 'typeZNSType',
    },
    {
      title: 'Chi phí',
      dataIndex: 'chiPhi',
      key: 'chiPhi',
      render: (value) => (
        <span className="neutral-gray-500">{formatPrice(value ?? 0)}</span>
      )
    }
  ]
  const columnsEmail: TableColumnsType<DataTypeSMS> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_, record) =>
        <div className='d-flex gap-2  align-center  h-full px-1' >
          <EditOutlined
            className={`border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoNetwork(record.key)} />
          <DeleteOutlined
            className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => openModalDelete(Number(record.key))}
          />
        </div >
    },
    {
      title: 'Nhà cung cấp',
      dataIndex: 'nhaMang',
      key: 'nhaMang',
      render: (text, record, index) => (
        <div className="d-flex align-center network">
          <img
            alt=""
            style={{ objectFit: 'contain' }}
            src={record.nhaMangImg}
            onError={(e) => {
              e.currentTarget.src = network_operator;
            }}
          />
          <span className="neutral-gray-500">{text}</span>
        </div>
      ),
    },
    {
      title: 'Số lương email cho 1 lần gửi',
      dataIndex: 'numberEmail',
      key: 'numberEmail',
      align: 'right',
      render: (text, record, index) => (
        <div className="d-flex align-left justify-end network">

          <span className="neutral-gray-500">{text} email</span>
        </div>
      ),
    },
    {
      title: 'Chi phí',
      dataIndex: 'chiPhi',
      key: 'chiPhi',
      align: 'right',
    }
  ]

  useEffect(() => {
    gListNetwork()

    return () => {
      setIsModalEdit(false)

      setInfoNetwork(undefined)

      setPagination({ current: 1, pageSize: 10, total: 0 })

      setListNetwork([])


    }

  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download } = getUserPermissions(permissionSlice, location.pathname)

  const [isModalEdit, setIsModalEdit] = useState(false)
  const [type, setType] = useState<CHANNELTYPE>(CHANNELTYPE.SMS);

  const [id, setId] = useState<number>();

  const [openDelete, setOpenDelete] = useState<boolean>(false)

  const [infoNetwork, setInfoNetwork] = useState<networkApi.INetwork>()

  const [listNetwork, setListNetwork] = useState<DataTypeSMS[]>([])

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });



  const gInfoNetwork = useThrottle(async (id: number) => {
    const result = await networkApi.getInfoNetwork(id, type)
    if (result?.status) {
      setInfoNetwork(result.data)
      setIsModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 1000)

  const gListNetwork = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await networkApi.getListNetwork(pageSize, pageCurent, type)
    if (result?.status) {

      setListNetwork(convertData(result.data, pageCurent, pageSize))
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const convertData = (data: networkApi.INetwork[], pageCurent: number, pageSize: number) => {
    const convertData = data.map((item) => ({
      key: item.id,
      nhaMang: item.title,
      nhaMangImg: URL_NETWORK + item.image,
      dauSo: item.numberPrefixes,
      soLuongKyTu: item.numberharacters,
      chiPhi: item.expense,
      category: item.brandName,
      typeZNSType: item.typeZNSType,
      numberEmail: item.numberEmail,
      messageType: item.messageType
    }))
    return convertData
  }


  const openModalDelete = (id: number) => {
    setId(id)
    setOpenDelete(true)
  }

  const closeModalDelete = () => {
    setId(undefined)
    setOpenDelete(false)
  }

  const onConfirmDelete = async () => {
    if (!id) return
    pushLoading(true)
    const result = await networkApi.deleteNotificationCosts(id)
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      gListNetwork(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)

  }

  useEffect(() => {
    gListNetwork()
  }, [type])
  return (
    <div className="notification-templates-management">

      <ModalDeleteManager
        isOpen={openDelete}
        title="Bạn có chắc chắn xóa nhà mạng này"
        titleDelete="Xóa nhà mạng"
        content="Nhà mạng và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />
      <Layout
        contentClassName="notification-fees-setting-content"
      >
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Marketing', },
            { title: 'Cài đặt phí gửi thông báo', },
          ]}
          title='Cài đặt phí gửi thông báo'
        />

        <div className="list-tabs">
          <div
            className={`one-tab ${type === CHANNELTYPE.SMS ? "active" : ""}`}
            onClick={() => setType(CHANNELTYPE.SMS)}
          >
            <div className="icon-svg">
              <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_9088_1787)">
                  <path d="M6.25009 7.36609C6.25009 7.565 6.32911 7.75577 6.46976 7.89642C6.61041 8.03707 6.80118 8.11609 7.00009 8.11609C7.199 8.11609 7.38977 8.03707 7.53042 7.89642C7.67107 7.75577 7.75009 7.565 7.75009 7.36609C7.75009 7.16718 7.67107 6.97641 7.53042 6.83576C7.38977 6.69511 7.199 6.61609 7.00009 6.61609C6.80118 6.61609 6.61041 6.69511 6.46976 6.83576C6.32911 6.97641 6.25009 7.16718 6.25009 7.36609ZM9.37509 7.36609C9.37509 7.565 9.45411 7.75577 9.59476 7.89642C9.73541 8.03707 9.92618 8.11609 10.1251 8.11609C10.324 8.11609 10.5148 8.03707 10.6554 7.89642C10.7961 7.75577 10.8751 7.565 10.8751 7.36609C10.8751 7.16718 10.7961 6.97641 10.6554 6.83576C10.5148 6.69511 10.324 6.61609 10.1251 6.61609C9.92618 6.61609 9.73541 6.69511 9.59476 6.83576C9.45411 6.97641 9.37509 7.16718 9.37509 7.36609ZM3.12509 7.36609C3.12509 7.565 3.20411 7.75577 3.34476 7.89642C3.48541 8.03707 3.67618 8.11609 3.87509 8.11609C4.074 8.11609 4.26477 8.03707 4.40542 7.89642C4.54607 7.75577 4.62509 7.565 4.62509 7.36609C4.62509 7.16718 4.54607 6.97641 4.40542 6.83576C4.26477 6.69511 4.074 6.61609 3.87509 6.61609C3.67618 6.61609 3.48541 6.69511 3.34476 6.83576C3.20411 6.97641 3.12509 7.16718 3.12509 7.36609ZM13.4563 4.65359C13.1032 3.81453 12.597 3.0614 11.9517 2.41453C11.3109 1.7714 10.5501 1.26019 9.71259 0.909839C8.85321 0.548901 7.94071 0.366089 7.00009 0.366089H6.96884C6.02196 0.370776 5.10478 0.558276 4.24228 0.927026C3.4119 1.28097 2.65831 1.79308 2.02353 2.43484C1.38446 3.08015 0.882901 3.83015 0.536026 4.66609C0.176651 5.53171 -0.00459886 6.45203 8.86448e-05 7.3989C0.0053906 8.48401 0.262107 9.55313 0.750089 10.5223V12.8973C0.750089 13.088 0.825814 13.2708 0.960606 13.4056C1.0954 13.5404 1.27821 13.6161 1.46884 13.6161H3.8454C4.81461 14.1041 5.88373 14.3608 6.96884 14.3661H7.00165C7.93759 14.3661 8.8454 14.1848 9.70009 13.8302C10.5334 13.484 11.2913 12.9787 11.9313 12.3427C12.5767 11.7036 13.0845 10.9567 13.4392 10.1239C13.8079 9.2614 13.9954 8.34421 14.0001 7.39734C14.0048 6.44578 13.8204 5.52234 13.4563 4.65359ZM11.0954 11.4973C10.0001 12.5817 8.54696 13.1786 7.00009 13.1786H6.97353C6.03134 13.1739 5.0954 12.9395 4.26884 12.4989L4.13759 12.4286H1.93759V10.2286L1.86728 10.0973C1.42665 9.27078 1.19228 8.33484 1.18759 7.39265C1.18134 5.83484 1.77665 4.37234 2.86884 3.27078C3.95946 2.16921 5.41728 1.55984 6.97509 1.55359H7.00165C7.7829 1.55359 8.54071 1.70515 9.25478 2.00515C9.95165 2.29734 10.5767 2.71765 11.1142 3.25515C11.6501 3.79109 12.072 4.41765 12.3642 5.11453C12.6673 5.8364 12.8188 6.60203 12.8157 7.39265C12.8063 8.9489 12.1954 10.4067 11.0954 11.4973Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_9088_1787">
                    <rect width="1em" height="1em" fill="white" transform="translate(0 0.366089)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="text">SMS</div>
          </div>

          <div
            className={`one-tab ${type === CHANNELTYPE.ZNS ? "active" : ""}`}
            onClick={() => setType(CHANNELTYPE.ZNS)}
          >
            <div className="icon-svg">
              <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.77081 1.93251C5.6837 1.92959 8.59366 1.91062 11.5051 1.93105C11.4847 2.50166 11.4525 3.12334 11.0702 3.5845C9.07963 6.0625 7.13138 8.5726 5.14228 11.0506C7.25689 11.0637 9.3715 11.055 11.4861 11.055C11.4467 11.5497 11.6204 12.1261 11.2993 12.5552C11.0979 12.8325 10.7331 12.8077 10.431 12.8106C7.78518 12.796 5.13936 12.8237 2.495 12.796C2.50229 12.2371 2.50813 11.6183 2.89924 11.1732C4.86646 8.7054 6.85702 6.25513 8.81549 3.78152C6.80303 3.78443 4.78911 3.76838 2.77665 3.79027C2.76352 3.1715 2.7679 2.55127 2.77081 1.93251Z" fill="currentColor" />
              </svg>
            </div>
            <div className="text">ZNS</div>
          </div>

          <div
            className={`one-tab ${type === CHANNELTYPE.EMAIL ? "active" : ""}`}
            onClick={() => setType(CHANNELTYPE.EMAIL)}
          >
            <div className="icon-svg">
              <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_9088_1770)">
                  <path d="M13.5 1.86322H0.5C0.223437 1.86322 0 2.08666 0 2.36322V12.3632C0 12.6398 0.223437 12.8632 0.5 12.8632H13.5C13.7766 12.8632 14 12.6398 14 12.3632V2.36322C14 2.08666 13.7766 1.86322 13.5 1.86322ZM12.875 3.59447V11.7382H1.125V3.59447L0.69375 3.25853L1.30781 2.46947L1.97656 2.98978H12.025L12.6938 2.46947L13.3078 3.25853L12.875 3.59447ZM12.025 2.98822L7 6.89447L1.975 2.98822L1.30625 2.46791L0.692188 3.25697L1.12344 3.59291L6.46094 7.74291C6.61444 7.86216 6.80328 7.92689 6.99766 7.92689C7.19203 7.92689 7.38088 7.86216 7.53438 7.74291L12.875 3.59447L13.3062 3.25853L12.6922 2.46947L12.025 2.98822Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_9088_1770">
                    <rect width="14" height="14" fill="white" transform="translate(0 0.366089)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="text">Email</div>
          </div>
        </div>

        {type === 1 &&
          <SMSFeesSetting
            columns={columnsSMS}
            listNetwork={listNetwork}
            infoNetwork={infoNetwork}
            pagination={pagination}
            isModalEdit={isModalEdit}

            setIsModalEdit={setIsModalEdit}
            gListNetwork={gListNetwork}
          />}

        {type === 2 &&
          <ZNSFeesSetting
            columns={columnsZNS}
            listNetwork={listNetwork}
            infoNetwork={infoNetwork}
            pagination={pagination}
            isModalEdit={isModalEdit}

            setIsModalEdit={setIsModalEdit}
            gListNetwork={gListNetwork}
          />}

        {type === 3 &&
          <EmailFeesSetting
            columns={columnsEmail}
            listNetwork={listNetwork}
            infoNetwork={infoNetwork}
            pagination={pagination}
            isModalEdit={isModalEdit}

            setIsModalEdit={setIsModalEdit}
            gListNetwork={gListNetwork}
          />}
      </Layout>
    </div>

  );
}
export default NotificationFeesSetting_V2

